import React, { memo, Fragment } from 'react'
import { ExpandableRow } from 'transfix-ui/components/ExpandableRow'
import { Grid, Box } from 'transfix-ui/core'
import { RoutingGuideRowProps } from 'apps/marketplace/apiTypes/carrierRoutingGuides'
import { RoutingGuidesRow } from './RoutingGuidesRow'
import { RoutingGuidesRowDetails } from './RoutingGuidesRowDetails'

interface IRoutingGuidesTableEntriesProps {
  routingGuides: RoutingGuideRowProps[]
}

export const RoutingGuidesTableEntries = memo<IRoutingGuidesTableEntriesProps>(
  ({ routingGuides }) => (
    <>
      <Box mb={2} pl={1}>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <strong>Lane Preferences</strong>
          </Grid>
          <Grid item xs={2}>
            <strong>Rate</strong>
          </Grid>
          <Grid item xs={3}>
            <strong>Created By</strong>
          </Grid>
          <Grid item xs={3} />
        </Grid>
      </Box>
      {routingGuides.map(routingGuide => {
        return (
          <Fragment key={routingGuide.uuid}>
            <ExpandableRow
              row={<RoutingGuidesRow {...routingGuide} />}
              details={<RoutingGuidesRowDetails {...routingGuide} />}
            />
          </Fragment>
        )
      })}
    </>
  )
)
